/**
 * Sayings in Kanglish (Kannada typed in Latin letters, as Bengaluru owners type on WhatsApp) for the meaning router
 * (ADR 0042), which had almost none and named 34% of Kanglish messages right. Spelling varies on purpose (beku/beeku,
 * eshtu/estu); near-misses teach the edges: someone else moving is chat, setting one's own rate is editCard. Never copied
 * from vectors/intents: the eval set measures what these generalise to (checked by word overlap, under 0.6 with every
 * case). A native speaker has not read them yet.
 */
export const KANGLISH_SAYINGS = {
    editCard: [
        "nanna rate 800 madi",
        "card alli nanna rate change maadbeeku",
        "nange Kannada Hindi eradu baratte card ge haaki",
        "nanna area Koramangala ge badlaysi",
        "naanu iga cooking kooda maadtini adu card ge add madi",
        "minimum 500 anta haaki nanna card nalli",
        "about alli 10 varsha anubhava ide anta bareyiri",
        "Whitefield beda HSR anta area haaki",
    ],
    helpOffer: [
        "hosadaagi bandavrige naanu help maadtini",
        "naanu mentor aagbeku",
        "ooru gottilladavrige daari torisoke ready idini",
        "hosbarige room hudukoke naanu sahaya maadbahudu",
        "nannanu helper list ge seriskoli",
        "hosa jana bandre nange heli guide maadtini",
        "Bengaluru ge hosaagi bandiro hudugirige help maadtini",
        "newcomers ge sahaya maadoke nanna hesru kodi",
    ],
    helpStop: [
        "innu mentor aagoke aagalla",
        "helper list inda nanna hesru tegdbidi",
        "hosbarige help maadoke time illa iga",
        "mentor kelsa saaku nillisi",
        "nanna hesru hosabara list alli beda",
        "ee tingalu inda yaarigu guide maadalla",
        "help offer cancel madi",
        "hosa janakke sahaya maadodu innu beda",
    ],
    moving: [
        "next month Mysore ge shift aagtidini kelsakke",
        "naanu Hyderabad ge hogtini kelsa sikkide",
        "kelsakoskara Bengaluru ge barta idini",
        "ooru bittu Chennai ge hogbeku kelsakke",
        "naanu Pune ge shift aagta iddini",
        "mundina vaara Mangalore ge hogtini job ge",
        "Bangalore ge bandu kelsa maadbeku antidini",
        "hosa kelsa sikkide Delhi ge relocate aagtini",
    ],
    earnings: [
        "October alli nange yeshtu duddu kai ge sikkitu",
        "ivaga varegu estu sampaadane aaytu",
        "yaaru innu nange duddu kodbeku",
        "last week eshtu sambla sikkitu",
        "nanna total payment estu aaytu nodi",
        "Koramangala mane inda baaki duddu bandideya",
        "ee varsha ondu lakh aaytaa nanna sampaadane",
        "mane avru kodbekaagiro pending amount total eshtu",
    ],
    schedule: [
        "shanivaara madhyahna 2 inda 4 booking ide ulisi",
        "naale enu bookings ive nange",
        "somvaarada booking cancel maadi",
        "bhanuvaara beligge 9 kke kelsa ide schedule alli haaki",
    ],
    market: [
        "adige maadoravrige full time ge sambla yeshtu nadiyutte",
        "plumber ondu visit ge eshtu tagotare",
        "8000 maid ge sari na",
        "Jayanagar alli driver sambla eshtu nadiyuttide",
        "painter ge dina ge estu rate",
        "babysitter ge 12000 jaasti aaytaa",
        "electrician fan haakoke eshtu charge maadtaare",
        "carpenter rate yeshtu ide ivaga",
    ],
    guide: [
        "illi SIM card hege tagobeku",
        "bank account open maadoke yaava documents beeku",
        "kadime baadige room elli sigutte",
        "aadhaar alli address change hege maadodu illi",
        "kelsakke hogoke metro na bus na yaavdu cheap",
        "ration card ge elli apply maadbeku",
        "hudugiyarige PG elli sigutte HSR hatra",
        "hosa ooralli gas connection hege tagolodu",
    ],
    find: [
        "nale mane clean maadoke yaaradru beku",
        "kitchen tap nillta illa",
        "ondu cook beeku dina eradu hotthu",
        "fan tirugta illa electrician kalsi",
        "weekend ge car odisoke driver beku",
        "bathroom alli neeru block aagide",
        "makkalu nodkoloke aaya beku",
        "gode paint maadsbeku yaradru gottideya",
    ],
    remember: [
        "nenapittko Raju ge 2000 advance kottiddini",
        "bardko maid ge sunday raje",
        "note madi gas cylinder 15 ne tareeku book maadbeku",
        "nenpu itko cook ge tingalu 9000 fix aagide",
        "ee vishya bardiko electrician next week bartini andru",
        "save madi driver ge tuesday raje beku anta",
        "note madko Seema 500 kodbeku nange",
        "mareyabaardu baadige 5 ne tareeku kodbeku bardko",
    ],
    askSelf: [
        "cook bagge naanu enu note maadidde",
        "plumber number elli bardidde nodi",
        "maid sambla eshtu anta bardidde",
        "driver bagge munche naanu enu helidde",
        "nanna notes alli gas booking date enu ide",
        "Raju ge advance estu kottidde anta bardidda",
        "kaleda vaara enu nenapittko andidde",
        "nanna notes nalli electrician hesaru ideya",
    ],
    askContact: [
        "Seema ge kelu naale barteera anta",
        "Raju ivattu free idaara",
        "Meera hatra kelu ondu cook gottideya",
        "Sunil ge kelu sanje barakke aagutta",
        "Manju plumber number kottara kelu",
        "Ravi ge kelu avra maid sunday bartaala",
        "Meera Mysore inda vaapas bandidaara",
        "Raju hatra kelu HSR alli room khaali ideya",
    ],
    setRule: [
        "Ravi ge nanna rate gottaagbaardu",
        "Seema nanna phone number nodbahudu",
        "Manju nange prashne kelbahudu bidi",
        "Raju ge nanna address torsabedi",
        "Meera ge nanna location helbedi",
        "Sunil nanna earnings nodoke bidbedi",
        "Ravi nanna hatra kelsa bagge kelbahudu ok",
        "Seema ge nanna schedule gottaagli parvagilla",
    ],
    chat: [
        "namaskara hegiddira",
        "thanks tumba help aaytu",
        "ivattu kelsa mugitu mane ge bande",
        "nanna tamma Hyderabad ge shift aagtidaane",
        "electrician ninne bandu wiring mugisidru",
        "Raju avrige 3000 kottaytu",
        "ok sari naale maataadona",
        "ivattu tumba male banthu traffic jaasti",
    ],
};
//# sourceMappingURL=sayings-kanglish.js.map